import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import SideBarItem from "./SideBarItem";
import DocumentationMenu from "./SideBarDocumentationMenu";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faRocket, faBox, faQuestionCircle, faGraduationCap, faReceipt, faStore } from "@fortawesome/free-solid-svg-icons";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons";

import * as Path from "../../Constants/GlobalConstant";

const Menu = (props) => {
    //render
    let itemsTodisplay = [];

    if (props.isAuthenticated) {
        itemsTodisplay.push(
            <SideBarItem key="0" to={Path.DASHBOARD_PATH} >
                <FontAwesomeIcon icon={faHome} fixedWidth className="mr-2" />
                {props.intl.messages.menuDashboard}
            </SideBarItem>
        );

        itemsTodisplay.push(
            <SideBarItem key="1" to={Path.PROFILE_PATH} >
                <FontAwesomeIcon icon={faUser} fixedWidth className="mr-2" />
                {props.intl.messages.menuProfile}
            </SideBarItem>
        );

        if (props.isDeveloper || props.isSuperAdminOrAppSuperAdmin || props.isSupportOrAppSupport) {
            itemsTodisplay.push(
                <SideBarItem key="2" to={Path.APPLICATIONS_PATH} >
                    <FontAwesomeIcon icon={faRocket} fixedWidth className="mr-2" />
                    {props.intl.messages.menuApplication}
                </SideBarItem>
            );
        }

        if (props.isDeveloper) {
            itemsTodisplay.push(
                <SideBarItem key="3" to={Path.BILLING_PATH} >
                    <FontAwesomeIcon icon={faCreditCard} fixedWidth className="mr-2" />
                    {props.intl.messages.menuBilling}
                </SideBarItem>
            );
            itemsTodisplay.push(
                <SideBarItem key="4" to={Path.SANDBOX_PATH} >
                    <FontAwesomeIcon icon={faBox} fixedWidth className="mr-2" />
                    {props.intl.messages.menuSandbox}
                </SideBarItem>
            );
        }
    } else {
        itemsTodisplay.push(
            <SideBarItem key="0" to={Path.HOME_PATH} >
                <FontAwesomeIcon icon={faHome} fixedWidth className="mr-2" />
                {props.intl.messages.menuHome}
            </SideBarItem>
        );
    }

    return (
        <div className="">
            <ul className="sidebar-menu">
                {itemsTodisplay}

                
                    <DocumentationMenu />

                    <li className="sidebar-header"> {props.intl.messages.menuHeaderExtras} </li>

                    <SideBarItem to={Path.STORE_PATH} >
                        <FontAwesomeIcon icon={faStore} fixedWidth className="mr-2" />
                        {props.intl.messages.menuStore}
                    </SideBarItem>

                    <SideBarItem to={Path.SUPPORT_PATH} >
                        <FontAwesomeIcon icon={faQuestionCircle} fixedWidth className="mr-2" />
                        {props.intl.messages.menuDocSupport}
                    </SideBarItem>

                    <SideBarItem to={Path.LEARN_PATH} >
                        <FontAwesomeIcon icon={faGraduationCap} fixedWidth className="mr-2" />
                        {props.intl.messages.menuDocLearn}
                    </SideBarItem>

                    <SideBarItem to={Path.PRICING_PATH} >
                        <FontAwesomeIcon icon={faReceipt} fixedWidth className="mr-2" />
                        {props.intl.messages.menuDocPricing}
                    </SideBarItem>

                    {/* Imagine a small footer...with mayby social networks */}
                    <div style={{ minHeight: "25px" }} />
                
            </ul>
        </div>
    )
};

Menu.defaultProps = {
    isAuthenticated: false,
    isDeveloper: false,
    isSuperAdminOrAppSuperAdmin: false,
    isSupportOrAppSupport: false
}

Menu.propTypes = {
    isAuthenticated: PropTypes.bool,
    isDeveloper: PropTypes.bool,
    isSuperAdminOrAppSuperAdmin: PropTypes.bool,
    isSupportOrAppSupport: PropTypes.bool
};

export default injectIntl(Menu)
